export default __webpack_public_path__ + "static/viinitie-banner-wedding-mobile.5c8ae2b55734439f3cfec8eb6743da01.webp";